import React from 'react'
import type { InsiderProductType } from 'src/typings/insider/insiderProduct'
import WishlistHeart from 'src/components/ui/WishlistHeart'
import { useWishlistContext } from 'src/contexts/WishlistContext/wishlist-context'
import { useProduct } from 'src/sdk/product/useProduct'
import { InsiderPriceTag } from '../InsiderPriceTag/InsiderPriceTag'
import { ProductSummary_ProductFragment } from '@generated/graphql'
import { sanitizeUrl } from 'src/utils/sanitizeUrl'
import '../styles.scss'

export interface InsiderProductCardProps {
  product: InsiderProductType
  index: number
}

export default function InsiderProductCardCampaign({
  product,
  index,
}: InsiderProductCardProps) {
  const { data, error } = useProduct(product.item_id!)

  if (error || !data?.product) return null

  const gqlProduct = data.product as unknown as ProductSummary_ProductFragment

  const ctxProducts = [
    {
      product: gqlProduct,
      chosenOption: 0,
      index,
    },
  ]

  const { removeProductFromWishlist, addProductToWishlist } =
    useWishlistContext()

  const productUrl = product.url ?? '#'
  const changeUrl = sanitizeUrl(true, productUrl)

  function getOriginalImageUrl(url: string): string {
    return url.replace(/(\/ids\/\d+)-\d+-\d+\//, '$1/')
  }

  const updateProductImageSize = getOriginalImageUrl(product.image_url)

  return (
    <div className="insider-product-card">
      <a href={changeUrl} className="product-link">
        <div className="product-content">
          <figure className="product-image">
            <img
              src={updateProductImageSize ?? '/placeholder.png'}
              alt={product.name ?? 'Produto sem nome'}
              loading="lazy"
            />
          </figure>

          <div className="product-name">{product.name}</div>

          <InsiderPriceTag
            listPrice={gqlProduct.offers.offers[0].listPrice}
            price={gqlProduct.offers.offers[0].price}
          />

          <WishlistHeart
            products={[gqlProduct]}
            hasBackgroundColor={false}
            isOnShelf={false}
            onEmptyHeartClick={() => addProductToWishlist(ctxProducts)}
            onFilledHeartClick={() =>
              removeProductFromWishlist([gqlProduct], index)
            }
            pdpPath={gqlProduct.slug}
          />
        </div>
      </a>
    </div>
  )
}
